import { ReactNode } from 'react';

import styles from './ErrorState.module.scss';

interface Props {
  title?: string;
  children?: ReactNode;
}

export const ErrorState = ({
  title = 'Yikes, something went wrong on our end.',
  children = 'Perhaps try reloading the page, or coming back later',
}: Props) => {
  return (
    <div className={styles.ErrorState}>
      <a href="https://wetransfer.com" className={styles.Logo}>
        <img src="/assets/images/logo.svg" alt="WeTransfer" />
      </a>
      <main className={styles.Wrapper}>
        <img
          className={styles.Spiral}
          src="/assets/images/spiral.svg"
          alt="Image of a spiral"
        />
        <h1 className={styles.Title}>{title}</h1>
        <p className={styles.Description}>{children}</p>
      </main>
    </div>
  );
};
